'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { useLocale } from '@src/i18n/LocaleProvider';
import { cn } from '@src/utils/tailwind';
interface CarouselArrowsProps {
  desktopVisible: boolean;
  overflowDesktop?: boolean;
  arrowPositions: {
    vertical: string;
    horizontal: string;
  };
  arrowIconColor?: string;
  arrowBackgroundColor?: string;
  previousSlide: (args: any) => void;
  nextSlide: (args: any) => void;
}
export const CarouselArrows = t0 => {
  const $ = _c(42);
  const {
    desktopVisible,
    arrowPositions,
    arrowBackgroundColor,
    arrowIconColor,
    previousSlide,
    nextSlide
  } = t0;
  const {
    t
  } = useLocale("carousel");
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== arrowBackgroundColor || $[1] !== arrowIconColor || $[2] !== arrowPositions.horizontal || $[3] !== arrowPositions.vertical || $[4] !== desktopVisible || $[5] !== nextSlide || $[6] !== previousSlide || $[7] !== t) {
    const commonStyles = ["[--arrow-size:40px] lg:[--arrow-offset-x:6px] xl:[--arrow-offset-x:12px]", "flex items-center justify-center bg-white absolute z-10 flex size-(--arrow-size) shrink-0 rounded-full shadow-[0px_1px_3px_0px_#16181940] transition-all hover:bg-bodi-gray-pearl"];
    const t6 = !desktopVisible;
    if ($[13] !== desktopVisible || $[14] !== t6) {
      t4 = cn("hidden", {
        "lg:block": desktopVisible,
        "md:hidden lg:hidden": t6
      });
      $[13] = desktopVisible;
      $[14] = t6;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    let t7;
    if ($[16] !== t) {
      t7 = t("previous-slide");
      $[16] = t;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    let t8;
    if ($[18] !== arrowBackgroundColor || $[19] !== arrowPositions.horizontal || $[20] !== arrowPositions.vertical) {
      t8 = {
        backgroundColor: arrowBackgroundColor,
        top: arrowPositions.vertical,
        left: arrowPositions.horizontal
      };
      $[18] = arrowBackgroundColor;
      $[19] = arrowPositions.horizontal;
      $[20] = arrowPositions.vertical;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    let t9;
    if ($[22] !== arrowIconColor) {
      t9 = <ChevronLeftIcon height="30px" width="30px" fill={arrowIconColor} />;
      $[22] = arrowIconColor;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    t5 = <button onClick={previousSlide} aria-label={t7} className={cn(commonStyles, "visible absolute z-10 flex size-10 shrink-0 items-center rounded-full sm:visible", {
      visible: desktopVisible,
      hidden: !desktopVisible
    })} style={t8}>{t9}</button>;
    t1 = nextSlide;
    if ($[24] !== t) {
      t2 = t("next-slide");
      $[24] = t;
      $[25] = t2;
    } else {
      t2 = $[25];
    }
    t3 = cn(commonStyles, "visible absolute z-10 flex size-10 shrink-0 items-center rounded-full sm:visible", {
      visible: desktopVisible,
      hidden: !desktopVisible
    });
    $[0] = arrowBackgroundColor;
    $[1] = arrowIconColor;
    $[2] = arrowPositions.horizontal;
    $[3] = arrowPositions.vertical;
    $[4] = desktopVisible;
    $[5] = nextSlide;
    $[6] = previousSlide;
    $[7] = t;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
  }
  let t6;
  if ($[26] !== arrowBackgroundColor || $[27] !== arrowPositions.horizontal || $[28] !== arrowPositions.vertical) {
    t6 = {
      backgroundColor: arrowBackgroundColor,
      top: arrowPositions.vertical,
      right: arrowPositions.horizontal
    };
    $[26] = arrowBackgroundColor;
    $[27] = arrowPositions.horizontal;
    $[28] = arrowPositions.vertical;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] !== arrowIconColor) {
    t7 = <ChevronRightIcon height="30px" width="30px" fill={arrowIconColor} />;
    $[30] = arrowIconColor;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  let t8;
  if ($[32] !== t1 || $[33] !== t2 || $[34] !== t3 || $[35] !== t6 || $[36] !== t7) {
    t8 = <button onClick={t1} aria-label={t2} className={t3} style={t6}>{t7}</button>;
    $[32] = t1;
    $[33] = t2;
    $[34] = t3;
    $[35] = t6;
    $[36] = t7;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== t4 || $[39] !== t5 || $[40] !== t8) {
    t9 = <div className={t4}>{t5}{t8}</div>;
    $[38] = t4;
    $[39] = t5;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  return t9;
};